export const APPLICATION_REDIRECTS = [
	{
		'route': '/store',
		'target': '/store/research'
	},
	{
		'route': '/user/sign-up-fly',
		'target': '/user/sign-up'
	},
	{
		'route': '/research/trademark',
		'target': '/research/trademark/tm-search'
	},
	{
		'route': '/research/research',
		'target': '/research/research/best-sellers'
	},
	{
		'route': '/research/keyword',
		'target': '/research/keyword/kw-workbench'
	},
	{
		'route': '/research/advertisement',
		'target': '/research/advertisement/ad-suggestions'
	},
	{
		'route': '/research/events',
		'target': '/research/events/event-calendar'
	},
	{
		'route': '/research',
		'target': '/'
	},
	{
		'route': '/upload',
		'target': '/'
	},
	{
		'route': '/upload/pod',
		'target': '/upload/pod/design-management'
	},
	{
		'route': '/upload/kdp',
		'target': '/'
	},
	{
		'route': '/upload/upload',
		'target': '/upload/upload/accounts-templates'
	},
	{
		'route': '/upload',
		'target': '/'
	},
	{
		'route': '/settings',
		'target': '/settings/account'
	}
];
